import React, { useState, useEffect } from 'react';
import { Box, Image, Flex, IconButton } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

const ImageSlide = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 300000); // Auto-scroll every 3 seconds
    setIntervalId(interval);
    return () => clearInterval(interval);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <Box mt={4} position="relative" width="100%" height={{ base: "40vh", md: "60vh" }} overflow="hidden" display="flex" alignItems="center">
      <Flex width="100%" transform={`translateX(-${currentIndex * 100}%)`} transition="transform 0.5s ease-in-out">
        {images.map((image, index) => (
          <Box key={index} width="100%" flex="0 0 auto">
            <Image
              src={image}
              alt={`Slide ${index}`}
              width="100%"
              height="100%"
              objectFit="contain" // Changed from "cover" to "contain"
              maxWidth="100%"
              maxHeight="100%"
              border="2px solid #ccc"
              boxShadow="lg"
            />
          </Box>
        ))}
      </Flex>
      <IconButton
        icon={<ChevronLeftIcon />}
        position="absolute"
        left="10px"
        top="50%"
        transform="translateY(-50%)"
        onClick={() => {
          prevSlide();
          resetInterval();
        }}
        aria-label="Previous Slide"
      />
      <IconButton
        icon={<ChevronRightIcon />}
        position="absolute"
        right="10px"
        top="50%"
        transform="translateY(-50%)"
        onClick={() => {
          nextSlide();
          resetInterval();
        }}
        aria-label="Next Slide"
      />
    </Box>
  );

  function resetInterval() {
    clearInterval(intervalId);
    const newInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    setIntervalId(newInterval);
  }
};

export default ImageSlide;